import { ref, watch } from 'vue'

/** Тема оформления. */
export type Theme = 'dark' | 'light'

const STORAGE_KEY = 'um_theme'

function resolveInitialTheme(): Theme {
  const saved = localStorage.getItem(STORAGE_KEY)
  return saved === 'light' || saved === 'dark' ? saved : 'dark'
}

// Глобальное состояние (singleton): одна тема на всё приложение, без Pinia.
const theme = ref<Theme>(resolveInitialTheme())

// Синхронизируем с <html data-theme> и localStorage. immediate — применяем сразу.
watch(
  theme,
  (value) => {
    document.documentElement.setAttribute('data-theme', value)
    localStorage.setItem(STORAGE_KEY, value)
  },
  { immediate: true },
)

/**
 * Управление светлой/тёмной темой. Состояние общее для всех вызовов.
 */
export function useTheme() {
  function toggle(): void {
    theme.value = theme.value === 'dark' ? 'light' : 'dark'
  }

  return { theme, toggle }
}
